import { Injectable } from "@angular/core";
import { BmarkSummaryViewFilterType } from "../models/bmark-summary-view-filter-type.enum";
import { Observable, ReplaySubject, Subject } from "rxjs";
import { auditTime } from "rxjs/operators";

// debounce requests with audit
const VIEW_FILTER_AUDIT_TIME = 200;

/**
 * A View Filter is an ephemeral filter
 * set at the level of a screen usually
 * by a quick access button, but never used in a profile.
 *
 * Product refer to this as a Quickfilter but that term is
 * reserved for use to ag-grid's freetext search facility
 */
@Injectable()
export class BmarkBlotterViewFilterSelectionService {
  protected requestSelection: ReplaySubject<BmarkSummaryViewFilterType> = new ReplaySubject(1);
  protected changeSelection = new Subject<BmarkSummaryViewFilterType>();
  public selection$: Observable<BmarkSummaryViewFilterType> = this.changeSelection.asObservable();

  constructor() {
    this.requestSelection
      .pipe(auditTime(VIEW_FILTER_AUDIT_TIME))
      .subscribe((type) => this.changeSelection.next(type));
  }

  next(type: BmarkSummaryViewFilterType) {
    if (BmarkSummaryViewFilterType[type] != null) {
      this.requestSelection.next(type);
    } else {
      this.requestSelection.next(BmarkSummaryViewFilterType.ALL);
    }
  }
}
